"use client";

import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router";
// import { CountryList } from "../services/CountryList";
// import { ProjectInquiry } from "../services/ProjectInquiry";
import api from "@/helper/api.interceptor";
import { useDispatch, useSelector } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
  setThankYouData,
} from "@/store/slices/inquirySlice";
import { usePathname, useRouter } from "next/navigation";
import { Toast } from "./Toast";

export default function HeaderInquiryForm({
  //   inquiryPopupObj,
  //   setInquiryPopupObj,
  //   inquiryPopup,
  //   setInquiryPopup,
  // propertylist,
}) {
  //   const navigate = useNavigate();

  const pathName = usePathname();
    const propertylist = useSelector((state) => state.inquiry.propertyList);
  const countryList = useSelector((state) => state.inquiry.countryList);
  const inquiryPopupObj = useSelector((state) => state.inquiry.inquiryPopupObj);
  const inquiryPopup = useSelector((state) => state.inquiry.inquiryPopup);

  const [countryFlag, setCountryFlag] = useState(false);
  //   const [countryList, setcountryList] = useState(null);
  const [isMobilescreen, setMobileScreen] = useState(false);
  const [search, setSearch] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [inquiryObj, setInquiryObj] = useState({
    agree_tandc: "1",
    agree_tandc_display: true,
    client_name: "",
    client_contact_no_display: "",
    client_contact_no: "",
    email_address: "",
    from_app: "true",
    master_user_id: "632",
    logged_in_master_user_id: "632",
    remarks: "",
    inquiry_from: "web",
    user_type: "N",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
    project_id: inquiryPopupObj?.project_id || "",
    // project_id:  "",
  });

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    setInquiryObj((prev) => ({
      ...prev,
      project_id: inquiryPopupObj?.project_id || "",
    }));
  }, [pathName, inquiryPopupObj, inquiryPopup]);

  const handleChange = (e) => {
    setFormSubmitted(false);
    const { name, value } = e.target;

    let updatedValue = value;

    // Prevent numbers in client_name (handle paste or typing)
    if (name === "client_name") {
      updatedValue = value.replace(/[0-9]/g, ""); // remove any digits
    }

    // For contact_no, allow only numbers
    if (name === "client_contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, ""); // remove non-numeric chars
      if (updatedValue.length > 10) {
        updatedValue = updatedValue.slice(0, 10); // limit to 10 digits
      }
    }

    // Email validation
    if (name === "email_address") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email_address: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email_address: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // Update state
    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };
  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.client_name.trim()) {
      newErrors.client_name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.client_name)) {
      newErrors.client_name = "Name must contain only letters";
    }

    if (!inquiryObj.client_contact_no_display.trim()) {
      newErrors.client_contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.client_contact_no_display)) {
      newErrors.client_contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email_address.trim()) {
      newErrors.email_address = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    // console.log(inquiryObj.project_id, "ID");
    if (!inquiryObj.project_id || inquiryObj.project_id === "") {
      newErrors.project_id = "project is required";
    }

    // console.log(newErrors);

    return newErrors;
  };

  useEffect(() => {
    setInquiryObj((prev) => ({
      ...prev,
      project_id: inquiryPopupObj?.project_id || "",
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const projectDetail = inquiryPopupObj?.project_id
      ? inquiryPopupObj
      : propertylist.find((p) => p.project_id == inquiryObj?.project_id);

    // console.log(inquiryPopupObj);
    inquiryObj.project_id = projectDetail?.project_id;

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      let client_contact_no =
        inquiryObj.country + " " + inquiryObj.client_contact_no_display;

      const finalInquiry = {
        ...inquiryObj,
        client_contact_no,
      };
      // console.log("Form Data:", finalInquiry);
      let response = await api.Projectinquiry(finalInquiry);
      if (response.success == 1) {
        setFormSubmitted(false);
        dispatch(setInquiryPopup(false));

        // navigate(`/${projectDetail.slug}/thankyou`, {
        //   state: {
        //     name: projectDetail.project_title,
        //     document: projectDetail.document_other_data
        //       ? projectDetail.document_other_data
        //       : [],
        //   },
        // });

        dispatch(
          setThankYouData({
            page_name: projectDetail.project_title,
            document: projectDetail.document_other_data
              ? projectDetail.document_other_data
              : [],
          }),
        );
        router.push(`/${projectDetail.slug}/thankyou`);

        setInquiryObj({
          client_name: "",
          client_contact_no_display: "",
          client_contact_no: "",
          email_address: "",
          from_app: "true",
          master_user_id: "632",
          logged_in_master_user_id: "632",
          remarks: "",
          inquiry_from: "web",
          user_type: "N",
          flag: "https://flagcdn.com/w40/in.webp",
          country: "91",
          project_id: "",
        });
      }

      Toast(response.message);
    }
  };

  const handleCountrySelect = (phonecode, flag) => {
    setInquiryObj({
      ...inquiryObj,
      country: phonecode,
      flag: flag,
    });
    setCountryFlag(false);
  };

  //   const loadCountry = async () => {
  //     try {
  //     //   const data = await CountryList();

  //       // Filter directly, without `await`
  //       const filtered = data.filter((country) => country.phonecode !== "92");

  //       setcountryList(filtered);
  //     } catch (err) {
  //       console.error("Error loading country data:", err);
  //     }
  //   };
  useEffect(() => {
    // loadCountry();
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }

    // console.log(propertylist);
  }, []);

  useEffect(() => {
    if (inquiryPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // console.log(propertylist);
  }, [inquiryPopup]);
  return (
    <>
      <div
        className={`click-overlay ${inquiryPopup ? "active" : ""} `}
        onClick={() => {
          setCountryFlag(false);
          dispatch(setInquiryPopup(false));
          // dispatch(setInquiryPopupObj({}));
        }}
      ></div>

      <div className="">
        <div
          className={`inquiry_popup relative ${
            inquiryPopup ? "inqury_active" : ""
          } `}
          onClick={() => {
            setCountryFlag(false);
          }}
        >
          <div
            className="close_icon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              dispatch(setInquiryPopup(false));
              dispatch(setInquiryPopupObj({}));
            }}
          >
            <span className="material-symbols-outlined">close</span>
          </div>
          <div className="inner-flex inner-flex-small">
            <div className="">
              <div className="section-title">
                <h2 className="semibold-fonts">Inquire Now</h2>
              </div>
              <div className="section-content">
                <p>Fill your latest details.</p>
              </div>
            </div>

            <form
              id="inquiry_form"
              name="inquiry_form"
              className="inner-flex"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="form_wrapper">
                {(pathName == "/" ||
                  pathName == "/projects" ||
                  pathName == "/career" ||
                  pathName == "/contact-us" ||
                  pathName == "/about-us" ||
                  pathName == "/channelpartner" ||
                  pathName.includes("/thankyou")) && (
                  <div className="contact_lable select_option select_apr relative">
                    <select
                      name="project_id"
                      value={inquiryObj.project_id || ""}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      className={`form-control form-control-gray 
    ${inquiryObj.project_id ? "ng-not-empty" : "ng-empty"} 
    ${errors.project_id ? "ng-invalid" : "ng-valid"} 
    ${inquiryObj.project_id ? "ng-touched" : ""} 
    ${formSubmitted && errors.project_id ? "error" : ""}`}
                      id="project_id"
                      tabIndex={11}
                    >
                      <option value="" style={{display:"none"}} disabled className="gray-color">
                        {/* Select Project */}
                      </option>

                      {propertylist &&
                        propertylist.map((data, index) => (
                          <option
                            key={index}
                            value={data.project_id}
                            className="capitalize"
                          >
                            {data.project_title}
                          </option>
                        ))}
                    </select>
                    <label
                      className="md-lable department_label"
                      htmlFor="project_id"
                    >
                      Project
                    </label>

                    <div className="fa-icon down_arrow">
                      {/* <span className="material-symbols-outlined">
                        keyboard_arrow_down
                      </span> */}
                      <img src="/images/icon/down_arrow.png" alt="" />
                    </div>
                  </div>
                )}
                <div className="contact_lable">
                  <span className="material-symbols-outlined icon-form-control">
                    person
                  </span>
                  <input
                    id="client_name"
                    name="client_name"
                    type="text"
                    className={`form-control form-control-gray form-control-iconpad ${
                      inquiryObj.client_name ? "ng-not-empty" : "ng-empty"
                    } ${errors.client_name ? "ng-invalid " : "ng-valid"} ${
                      inquiryObj.client_name ? "ng-touched" : ""
                    } ${
                      formSubmitted &&
                      (!inquiryObj.client_name || errors.client_name)
                        ? "error"
                        : ""
                    } `}
                    value={inquiryObj.client_name}
                    onChange={handleChange}
                    tabIndex={12}
                  />
                  <label className="md-lable" htmlFor="client_name">
                    Name
                  </label>
                  <div className="valid-icon-of-form">
                    <img
                      loading="lazy"
                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div className="contact_lable">
                  <span className="material-symbols-outlined icon-form-control">
                    alternate_email
                  </span>
                  <input
                    id="email_address"
                    name="email_address"
                    type="email"
                    className={`form-control form-control-gray form-control-iconpad ${
                      inquiryObj.email_address ? "ng-not-empty" : "ng-empty"
                    }
                                                                     ${
                                                                       formSubmitted &&
                                                                       (!inquiryObj.email_address ||
                                                                         errors.email_address)
                                                                         ? "error"
                                                                         : ""
                                                                     }
                                                                     ${
                                                                       errors.email_address
                                                                         ? "ng-invalid"
                                                                         : "ng-valid"
                                                                     } ${
                                                                       inquiryObj.email_address
                                                                         ? "ng-touched"
                                                                         : ""
                                                                     }`}
                    value={inquiryObj.email_address}
                    onChange={handleChange}
                    tabIndex={13}
                  />

                  <label className="md-lable" htmlFor="email_address">
                    Email
                  </label>
                  <div className="valid-icon-of-form">
                    <img
                      loading="lazy"
                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div className="contact_lable  relative">
                  <span className="material-symbols-outlined icon-form-control">
                    dialpad
                  </span>
                  <input
                    id="client_contact_no_display"
                    name="client_contact_no_display"
                    type="text"
                    className={`form-control form-control-gray contact-form form-control-iconpad ${
                      inquiryObj.client_contact_no_display
                        ? "ng-not-empty"
                        : "ng-empty"
                    } ${
                      formSubmitted &&
                      (!inquiryObj.client_contact_no_display ||
                        errors.client_contact_no_display)
                        ? "error"
                        : ""
                    }
                                                                    ${
                                                                      !errors.client_contact_no_display &&
                                                                      inquiryObj
                                                                        .client_contact_no_display
                                                                        .length ===
                                                                        10
                                                                        ? "ng-valid"
                                                                        : "ng-invalid"
                                                                    } ${
                                                                      inquiryObj.client_contact_no_display
                                                                        ? "ng-touched"
                                                                        : ""
                                                                    }`}
                    value={inquiryObj.client_contact_no_display}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    minLength="10"
                    maxLength="10"
                    tabIndex={14}
                  />
                  <label
                    className="md-lable contact_code"
                    htmlFor="client_contact_no_display"
                  >
                    Mobile Number
                  </label>
                  <div className="valid-icon-of-form">
                    <img
                      loading="lazy"
                      src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                      alt=""
                    />
                  </div>
                  <div className="conatct_number_input">
                    <div
                      className="country_code_data"
                      onClick={(event) => {
                        setCountryFlag(true);
                        event.stopPropagation();
                      }}
                      ng-click="country_code_click(); $event.stopPropagation();"
                    >
                      <div className="contact_country_flag">
                        <img
                          loading="lazy"
                          src={inquiryObj.flag}
                          alt="reecosys"
                        />
                      </div>
                      <div>&nbsp;+{inquiryObj.country}</div>
                      <div>
                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`country_code_list_data ${
                      countryFlag ? "active" : ""
                    } `}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="search_c-code">
                      <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                      />
                    </div>
                    <ul>
                      {countryList != undefined &&
                        countryList.length > 0 &&
                        countryList
                          .filter(
                            (item) =>
                              item.phonecode.toString().includes(search) ||
                              item.nicename
                                .toLowerCase()
                                .includes(search.toLowerCase()),
                          )
                          .map((item, index) => (
                            <li
                              key={`${item.phonecode}-${item.nicename}-${index}`}
                            >
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCountrySelect(
                                    item.phonecode,
                                    item.flag,
                                  );
                                }}
                              >
                                <div>
                                  <img src={item.flag} alt="country" />
                                </div>
                                <span className="display_country_code">
                                  +{item.phonecode}
                                </span>{" "}
                                {item.nicename}
                              </div>
                            </li>
                          ))}
                    </ul>
                  </div>
                </div>

                <div className="contact_lable commentbox">
                  <span className="material-symbols-outlined icon-form-control">
                    chat_bubble
                  </span>
                  <textarea
                    id="remarks"
                    name="remarks"
                    type="text"
                    className={`form-control form-control-gray form-control-iconpad ${
                      inquiryObj.remarks ? "ng-not-empty" : "ng-empty"
                    } ${inquiryObj.remarks ? "ng-touched" : ""}`}
                    value={inquiryObj.remarks}
                    onChange={handleChange}
                    rows="1"
                    tabIndex={15}
                  ></textarea>

                  <label className="md-lable" htmlFor="remarks">
                    Comments
                  </label>
                </div>
                <p style={{ width: "100%" }}>
                  By submitting this form, you agree to the{" "}
                  <a href="javascript:void(0);" className="hover-color-link">
                    Terms & Conditions
                  </a>{" "}
                  of NB Buildcon.
                </p>
                <div className="sunmit-project-btn">
                  <button
                    className="reecosys-template-button button-style-primary"
                    type="submit"
                    tabIndex={16}
                  >
                    <span className="material-symbols-outlined">send</span>
                    {formSubmitted &&
                    Object.values(errors).every((err) => err === "") ? (
                      <p>Please Wait...</p>
                    ) : (
                      <p>Submit</p>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
